module.exports = "https://qiaozuji-flms-public.cdn.qiaozuji.com/resource/h5/img/langing_page_01.png";